import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiGet } from "../api/api";
import CampanhaForm from "../components/CampanhaForm";

export default function CampoInventario() {
  const { inventarioId } = useParams();

  const [inventario, setInventario] = useState(null);
  const [molduras, setMolduras] = useState([]);
  const [ultimasCampanhas, setUltimasCampanhas] = useState({});
  const [loading, setLoading] = useState(true);

  // ============================
  // Carregar últimas campanhas por face
  // ============================
  async function carregarUltimasCampanhas(faces) {
    const resultado = {};

    for (const face of faces) {
      try {
        const data = await apiGet(`/campanhas/face/${face.id}/ultimos`);
        resultado[face.id] = data;
      } catch (e) {
        resultado[face.id] = [];
      }
    }

    setUltimasCampanhas(resultado);
  }

  // ============================
  // Carregar inventário + molduras + faces
  // ============================
  async function load() {
    setLoading(true);

    const inv = await apiGet(`/inventario/${inventarioId}`);
    setInventario(inv);

    const md = await apiGet(`/molduras/inventario/${inventarioId}`);
    setMolduras(md);

    const todasAsFaces = md.flatMap((m) => m.faces || []);
    await carregarUltimasCampanhas(todasAsFaces);

    setLoading(false);
  }

  useEffect(() => {
    load();
  }, [inventarioId]);

  if (loading || !inventario) {
    return <div style={{ padding: 20 }}>A carregar…</div>;
  }

  return (
    <div style={{ padding: 20 }}>
      {/* ============================
          CABEÇALHO
      ============================ */}
      <h1>📍 Inventário #{inventario.id}</h1>

      <p>
        <strong>Tipo Localização:</strong> {inventario.tipo_localizacao}
      </p>

      <p>
        <strong>Operador:</strong> {inventario.operador?.nome}
      </p>

      <hr />

      {/* ============================
          MOLDURAS (READ-ONLY)
      ============================ */}
      {molduras
        .filter((m) => m.tipo_moldura === "COMERCIAL")
        .map((m) => {
          // 🔤 ORDENAR FACES POR IDENTIFICADOR (A, B, C, D...)
          const facesOrdenadas = [...(m.faces || [])].sort((a, b) => {
            const idA = (a.identificador || "").toString().toUpperCase();
            const idB = (b.identificador || "").toString().toUpperCase();
            if (idA < idB) return -1;
            if (idA > idB) return 1;
            return 0;
          });

          return (
            <div
              key={m.id}
              style={{
                padding: 15,
                border: "1px solid #ccc",
                borderRadius: 8,
                marginBottom: 20,
              }}
            >
              <h3>Moldura #{m.id}</h3>

              {/* FOTO DA MOLDURA */}
              {m.foto_path && (
                <img
                  src={m.foto_path}
                  alt="Foto moldura"
                  style={{
                    width: 140,
                    height: 140,
                    objectFit: "cover",
                    borderRadius: 8,
                    border: "1px solid #aaa",
                    marginBottom: 10,
                  }}
                />
              )}

              <p>
                <strong>Lado Via:</strong> {m.lado_via}
                <br />
                <strong>Formato:</strong> {m.formato}
              </p>

              <hr />

              {/* ============================
                  FACES (ORDENADAS)
              ============================ */}
              {facesOrdenadas.map((f) => (
                <div
                  key={f.id}
                  style={{
                    marginBottom: 20,
                    paddingBottom: 15,
                    borderBottom: "1px dashed #ccc",
                  }}
                >
                  {/* FOTO DA FACE */}
                  {f.foto_path && (
                    <img
                      src={f.foto_path}
                      alt="Foto face"
                      style={{
                        width: 100,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 6,
                        border: "1px solid #aaa",
                        marginBottom: 8,
                      }}
                    />
                  )}

                  <h4
                    style={{
                      margin: "5px 0",
                      padding: "4px 8px",
                      background: "#e3f2fd",
                      borderRadius: 4,
                      display: "inline-block",
                    }}
                  >
                    Face #{f.id}
                  </h4>

                  <div style={{ marginBottom: 5 }}>
                    <strong>
                      {f.lado} — {f.identificador}
                    </strong>
                  </div>

                  {/* ÚLTIMAS CAMPANHAS (MÁX 5) */}
                  {ultimasCampanhas[f.id]?.length > 0 && (
                    <div
                      style={{
                        background: "#f5f5f5",
                        padding: 10,
                        borderRadius: 6,
                        marginBottom: 10,
                      }}
                    >
                      <strong>Últimos registos:</strong>
                      <ul style={{ margin: 0, paddingLeft: 18 }}>
                        {ultimasCampanhas[f.id]
                          .slice(0, 5)
                          .map((c) => (
                            <li key={c.id}>
                              {new Date(
                                c.data_registo
                              ).toLocaleDateString()}{" "}
                              — <strong>{c.marca}</strong>{" "}
                              {c.campanha && <>| {c.campanha}</>}
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}

                  {/* FORMULÁRIO DE CAMPANHA */}
                  <CampanhaForm faceId={f.id} onSuccess={load} />
                </div>
              ))}
            </div>
          );
        })}
    </div>
  );
}
